<template>
  <md-layout md-align="end" md-flex="100" class="custom-footer">
  {{ softwareName }}
  </md-layout>
</template>

<script>
export default {
  name: 'app-footer',
  props: {
    name: String
  },
  data () {
    return {
    }
  },
  computed: {
    softwareName () {
      return this.name + ', ©' + this.currentYear
    },
    currentYear () {
      return new Date().getFullYear()
    }
  }
}
</script>

<style>
  .custom-footer{
    padding: 4px 16px;
    background: #f6f6f6;
    font-size: 12px;
    color: #777777;
    max-height: 25px;
  }
</style>



// WEBPACK FOOTER //
// main-footer.vue?710f1236